import { render, staticRenderFns } from "./DayTripModifiers.vue?vue&type=template&id=078caf20&"
import script from "./DayTripModifiers.vue?vue&type=script&lang=js&"
export * from "./DayTripModifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports